<ng-container *ngIf="mediaList">
    <app-image-slider [type]="'thumbs'" [watchList]="true" [items]="mediaList" [class.refresh]="mediaList.length">
    </app-image-slider>
</ng-container>
<ng-container *ngIf="mediaList2">
    <app-image-slider [type]="'thumbs'" [watchList]="true" [items]="mediaList2">
    </app-image-slider>
</ng-container>
